<template>
  <component
    :is="currentElement"
    :el="el"
    :key="currentKey"
    :custom-mode="customMode"
    :document="document"
    :recipient="recipient"
    @end-drag="onDragEnd"
    @remove-drag="onRemove"
    @on-selected="OnRender"
  />
</template>

<script>
import Date from "./Date.vue";
import Paragraphe from "./Paragraphe.vue";
import Signature from "./Signature.vue";
import Image from "./Image.vue";

export default {
  components: {
    Date,
    Paragraphe,
    Signature,
  },
  props: {
    el: {
      required: true,
    },
    customMode: {
      type: Boolean,
      default: false,
    },
    document: {
      default: () => {},
    },
    recipient: {
      default: () => -1,
    },
  },
  data: () => ({
    currentElement: null,
    currentKey: 0,
  }),
  methods: {
    onDragEnd(val) {
      if (val.top === null) {
        this.currentKey++;
      } else {
        this.$emit("end-drag", val);
      }
    },
    onRemove(val) {
      this.$emit("remove-drag", val);
    },
    OnRender(val) {
      this.$emit("on-selected", val);
    },
    onInit() {
      try {
        const wrapper = {
          date: () => Date,
          text: () => Paragraphe,
          input: () => Paragraphe,
          signature: () => Signature,
          imagecomp: () => Image,
        };
        this.currentElement = wrapper[this.el.type]();
      } catch (err) {
        this.currentElement = Paragraphe;
      }
    },
  },
  created() {
    this.onInit();
  },
};
</script>

<style>
.p-close {
  position: absolute;
}
.cursor {
  cursor: pointer;
}
.form {
  border: 1px solid #ccc;
  position: relative;
  border-radius: 2px;
}
.p-close {
  width: 24px;
  background: white;
  top: -12px;
  left: calc(100% - 12px);
  position: absolute;
  height: 24px;
  border: 1px solid rgb(138, 132, 132);
  border-radius: 50%;
}
.cs-input {
  letter-spacing: 0.1px !important;
  width: 100%;
  /* height: 25px !important; */
  border: none;
  outline-style: solid;
  outline-width: 2px;
  border-radius: 3px;
}
.cs-input:focus-visible {
  outline-style: solid;
  outline-width: 2px;
  border-radius: 3px;
}
</style>
